
import { useState, useEffect } from 'react';
import { useAccount } from 'wagmi';
import { checkWalletInitialized, getExistingBroCode } from '@/lib/broCode';
import { InitiationStep } from './types';

export const useWalletInitialized = () => {
  const { address, isConnected } = useAccount();
  const [alreadyInitialized, setAlreadyInitialized] = useState<boolean>(false);
  const [completionRank, setCompletionRank] = useState<string>("");
  const [completionBrocode, setCompletionBrocode] = useState<string>("");
  const [initialStep, setInitialStep] = useState<number | null>(null);
  
  useEffect(() => {
    const checkInitialization = async () => {
      if (!isConnected || !address) return;
      
      try {
        const isInitialized = await checkWalletInitialized(address);
        
        if (isInitialized) {
          console.log("Wallet already initialized");
          setAlreadyInitialized(true);
          
          // Fetch existing BroCode
          const broData = await getExistingBroCode(address);
          if (broData) {
            setCompletionRank(broData.rank);
            setCompletionBrocode(broData.brocode);
            // Skip to completion step
            setInitialStep(InitiationStep.COMPLETION);
          }
        } else {
          console.log("Wallet not yet initialized");
        }
      } catch (error) {
        console.error("Error checking wallet initialization:", error);
      }
    };
    
    checkInitialization();
  }, [isConnected, address]);

  return { alreadyInitialized, completionRank, completionBrocode, initialStep };
};
